function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { ThumbDown, ThumbDownOutlined, ThumbUp, ThumbUpOutlined } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core';
import { RadioGroup } from '../RadioGroup';
import useFormHelpers from '../../hooks/useFormHelpers';
const useStyles = makeStyles(theme => ({
  negativeChecked: {
    color: `${theme.palette.error[500]} !important`
  },
  positiveChecked: {
    color: `${theme.palette.success[500]} !important`
  }
}));

const BooleanRating = ({
  NegativeCheckedIcon,
  NegativeIcon,
  negativeLabel,
  onChange,
  PositiveCheckedIcon,
  PositiveIcon,
  positiveLabel,
  value: selectedOption,
  ...props
}) => {
  const classes = useStyles(); // we cannot have boolean values; all values get turned into strings.  See https://material-ui.com/api/radio/#props

  const options = [{
    value: 'true',
    label: negativeLabel,
    checkedIcon: React.createElement(PositiveCheckedIcon, null),
    icon: React.createElement(PositiveIcon, null),
    props: {
      classes: {
        checked: classes.positiveChecked
      }
    }
  }, {
    value: 'false',
    label: positiveLabel,
    checkedIcon: React.createElement(NegativeCheckedIcon, null),
    icon: React.createElement(NegativeIcon, null),
    props: {
      classes: {
        checked: classes.negativeChecked
      }
    }
  }];

  function coerceValue(selectedOption) {
    switch (selectedOption) {
      case true:
        return 'true';

      case false:
        return 'false';

      default:
        return undefined;
    }
  }

  return React.createElement(RadioGroup, _extends({
    getCheckedIcon: option => option.checkedIcon,
    getIcon: option => option.icon,
    getOptionKey: option => option.value,
    getOptionLabel: option => option.label,
    getOptionProps: option => option.props,
    getOptionValue: option => option.value,
    onChange: value => onChange(value === 'true'),
    options: options,
    outputOptionLabel: false,
    row: true,
    value: coerceValue(selectedOption)
  }, props));
};

BooleanRating.propTypes = {
  NegativeCheckedIcon: PropTypes.elementType,
  NegativeIcon: PropTypes.elementType,
  negativeLabel: PropTypes.string,
  PositiveCheckedIcon: PropTypes.elementType,
  PositiveIcon: PropTypes.elementType,
  positiveLabel: PropTypes.string
};
BooleanRating.defaultProps = {
  NegativeCheckedIcon: ThumbDown,
  NegativeIcon: ThumbDownOutlined,
  negativeLabel: 'Thumbs Down',
  PositiveCheckedIcon: ThumbUp,
  PositiveIcon: ThumbUpOutlined,
  positiveLabel: 'Thumbs Up'
};

const LinkedBooleanRating = props => {
  const helpers = useFormHelpers(props);
  return React.createElement(BooleanRating, helpers);
};

LinkedBooleanRating.propTypes = {
  name: PropTypes.string.isRequired
};
export { BooleanRating, LinkedBooleanRating };